import Container from 'components/Container'
import { SkeletonItem } from 'components/Skeleton'

const SkeletonRow = () => (
	<Container display="flex" alignItems="center" justifyContent="space-between" space="md">
		<SkeletonItem />
		<SkeletonItem $width={150} />
	</Container>
)

const AccessTabSkeleton = () => (
	<Container space="md" spaceDirection="vertical">
		<SkeletonRow />
	</Container>
)

export default AccessTabSkeleton
